var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-9 border-right" }, [
        _c("div", [
          _c("h4", {
            staticClass: "ml-1",
            domProps: { textContent: _vm._s(_vm.item.cart.title) },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "ml-1",
            domProps: {
              innerHTML: _vm._s(_vm.item.cart.description.substring(0, 250)),
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-3 pt-05 text-center" }, [
        _c("span", {
          staticClass: "font-large-1",
          domProps: {
            textContent: _vm._s(
              this.$options.filters.currency(_vm.item.price, _vm.site_tax)
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "font-small-1 text-muted d-block",
            staticStyle: { "margin-top": "-5px" },
          },
          [_vm._v("inc " + _vm._s(_vm.site_tax.name))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: " mt-05" }, [
          _c("span", { staticClass: "font-small-2 text-center" }, [
            _vm._v(_vm._s(_vm.__("globals.quantity")) + ":"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex mb-05 mt-05" }, [
            _c(
              "div",
              { staticClass: "m-auto" },
              [
                _c("NumberInputSpinner", {
                  attrs: { min: 1, max: 5000, step: 1, integerOnly: true },
                  model: {
                    value: _vm.qty,
                    callback: function ($$v) {
                      _vm.qty = $$v
                    },
                    expression: "qty",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-center mb-05" }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-flat-danger",
              staticStyle: { border: "none" },
              on: { click: _vm.destroy },
            },
            [
              _c("i", { staticClass: "feather icon-x" }),
              _vm._v(" " + _vm._s(_vm.__("globals.remove"))),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }